module.exports = __webpack_public_path__ + "img/FCB-star.f28f1fd4.svg";